module.exports = __webpack_public_path__ + "static/media/The Great Escape.fff4b15e.jpg";